import {NgModule} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { InsightsDepartmentPerformanceComponent } from './insights-department-performance.component';
import { HighchartsChartModule } from 'highcharts-angular';


@NgModule({ declarations: [InsightsDepartmentPerformanceComponent],
    exports: [InsightsDepartmentPerformanceComponent], imports: [BrowserModule,
        FormsModule,
        TooltipModule.forRoot(),
        HighchartsChartModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class InsightsDepartmentPerformanceModule { }
